import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import * as Yup from "yup";
import CustomInput from "../../../../Components/input/CustomInput";
import gallery from "../../../../Utils/Images/Gallery Send.png";
import cross from "../../../../Utils/Images/cross.png";
import SelectRecipeModal from "../../../../Components/Modal/SelectRecipe";
import { GetSingleDiet } from "../../../../APIs/Function/Workout/DietPlans/GetSingleDIet";
import { handleEditDiet } from "../../../../APIs/Function/Workout/DietPlans/EditDiet";
import { GetDietCategory } from "../../../../APIs/Function/DietCategory/GetProductCategory";

const EditDietPlans = () => {
  const { id } = useParams();
  const [previewImage, setPreviewImage] = useState([]);
  const [singleDiet, setSingleDiet] = useState({});
  const [category, setCategory] = useState([]);

  useEffect(() => {
    handleSingleDiet();
  }, []);
  console.log(singleDiet);

  const [tempRecipe, setTempRecipe] = useState();
  const validationSchema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    image: Yup.mixed().required("Image is required"),
  });
  const [recipeType, setRecipeType] = useState(4);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRecipeData, setSelectedRecipeData] = useState([]);
  const onClose = () => {
    setOpen(false);
    setRecipeType(4);
    setSearchTerm("");
    setSelectedRecipeData([]);
  };

  const onOpen = () => {
    setOpen(true);
  };

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    image: null,
    recipe_id: [],
  });
  const initialFormData = {
    title: "",
    image: null,
    recipe_id: [],
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  console.log(tempRecipe);
  const handleSelectRecipes = (selectedRecipes) => {
    const selectedRecipeIds = selectedRecipes.map((recipe) => recipe.id);
    setFormData({
      ...formData,
      recipe_id: selectedRecipeIds,
    });
  };

  const handleImageChange = (event) => {
    const image = event.target.files[0];
    if (image) {
      setFormData({
        ...formData,
        image: image,
      });
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };
      reader.readAsDataURL(image);
    } else {
      setPreviewImage(gallery);
    }
  };

  const handleRemoveRecipe = (recipeIndex) => {
    const updatedTempRecipe = [...tempRecipe];
    updatedTempRecipe.splice(recipeIndex, 1);
    setTempRecipe(updatedTempRecipe);
  };
  const handleSubmit = async (event) => {
    if (tempRecipe.length === 0) {
      alert("Please Select Recipe");
      return;
    } else {
      event.preventDefault();
      try {
        await validationSchema.validate(formData, { abortEarly: false });
        setLoading(true);
        let res = await handleEditDiet(formData, id);
        setLoading(false);
        if (res.s) {
          alert("Data Edited Successfully");
          navigate("/dietplans");
          setFormData(initialFormData);
        } else {
          console.log("API request was not successful:", res.error);
        }
      } catch (error) {
        setLoading(false);
        if (error instanceof Yup.ValidationError) {
          const validationErrors = error.inner.map((e) => e.message);
          alert(validationErrors.join("\n"));
        } else {
          console.log("An unexpected error occurred:", error);
        }
      }
    }
  };

  const handleSingleDiet = async () => {
    try {
      setLoading(true);
      let res = await GetSingleDiet(id);
      setSingleDiet(res.r);
      setTempRecipe(res.r.recipe);
      const recipeIds = singleDiet.recipe?.map((recipe) => recipe.id) || [];
      setFormData({
        ...formData,
        title: res.r.title,
        dietID: id,
        image: res.r.photo,
        recipe_id: res.r.recipe.map((e) => e.id),
      });
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const getcategory = async () => {
    try {
      let res = await GetDietCategory();
      console.log(res.r);
      setCategory(res.r);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getcategory();
  }, []);
  return (
    <>
      {/* header */}

      <Box>
        <Box
          sx={{
            bgcolor: "#31AEF4",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: { xs: "50px", md: "70px", lg: "70px" },
            p: "10px",
            boxSizing: "border-box",
          }}
        >
          <Link to={"/dietplans"}>
            <Box
              sx={{
                height: { xs: "50px", md: "60px", lg: "60px" },
                display: "flex",
                alignItems: "center",
              }}
            >
              <img height={"100%"} src={backbluebtn} alt="back" />
            </Box>
          </Link>
          <Box>
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: { md: "30px", sm: "20px" },
                fontWeight: 600,
                lineHeight: "36px",
                color: "#FFFFFF",
              }}
            >
              Edit Diet Plan
            </Typography>
          </Box>
          <Box>
            <CustomButton
              sx={{
                width: { xs: "40px", md: "50px", lg: "80px" },
                height: { xs: "10px", md: "50px", lg: "50px " },
              }}
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress></CircularProgress> : "Save"}
            </CustomButton>
          </Box>
        </Box>
        {/* form */}
        <Container sx={{ mt: "30px" }}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomInput
                  label="Title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <label htmlFor="file-image-input">
                  <Box
                    sx={{
                      width: "100%",
                      height: "150px",
                      bgcolor: "#F4F4F4",
                      p: "20px",
                      boxSizing: "border-box",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center ",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Box sx={{ width: "100px", height: "100px", mb: "10px" }}>
                      <img
                        height={"100%"}
                        width={"100%"}
                        src={
                          previewImage.length // First priority: previewImage
                            ? previewImage
                            : singleDiet?.photo // Second priority: singleDiet.photo
                            ? `https://api-qhealth.equitysofttechnologies.com/upload/images/${singleDiet.photo}`
                            : gallery // Default: gallery
                        }
                        alt="preview"
                      />
                    </Box>
                    <Typography>Upload Image</Typography>
                  </Box>
                </label>
                <input
                  accept="image/*"
                  type="file"
                  id="file-image-input"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  sx={{
                    textAlign: "left",
                    width: "100%",
                  }}
                  required
                >
                  <InputLabel
                    sx={{
                      backgroundColor: "#FFF",
                    }}
                  >
                    Diet Category
                  </InputLabel>
                  <Select
                    fullWidth
                    name="diet_category"
                    value={formData.product_category}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        diet_category: e.target.value,
                      })
                    }
                    sx={{ textAlign: "left" }}
                  >
                    {category?.map((e, i) => (
                      <MenuItem key={i} value={e.id}>
                        {e.category}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </form>
        </Container>
        <Box
          sx={{
            height: "380px",
            width: "75%",
            m: "auto",
            border: "0.5px solid #E8E8E8",
            mt: "20px",
            p: 2,
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "left" }}>
            <CustomButton onClick={onOpen} sx={{ width: "20%" }}>
              Select Recipes +
            </CustomButton>
          </Box>
          <Grid sx={{ mt: "15px" }} container>
            {/* first column */}
            <Grid item xs={0.5} md={0.5}>
              {tempRecipe ? ( // Check if tempRecipe exists before mapping
                tempRecipe.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {i + 1}
                    </Typography>
                  </Paper>
                ))
              ) : (
                <Box sx={{ ml: "400px", mt: "50px" }}>
                  <CircularProgress></CircularProgress>
                </Box>
              )}
            </Grid>

            {/* Second Column */}

            <Grid item xs={2} md={2}>
              {tempRecipe ? (
                tempRecipe.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box sx={{ width: "40px", height: "40px" }}>
                      <img
                        width={"100%"}
                        height={"100%"}
                        src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${e.recipe_images[0].r_images}`}
                        alt=""
                      />
                    </Box>
                  </Paper>
                ))
              ) : (
                <></>
              )}
            </Grid>

            {/* Third Column */}

            <Grid item xs={7.5} md={7.5}>
              {tempRecipe ? (
                tempRecipe.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {e.title}
                    </Typography>
                  </Paper>
                ))
              ) : (
                <></>
              )}
            </Grid>

            {/* Sixth Column */}
            <Grid item xs={2} md={2}>
              {tempRecipe ? (
                tempRecipe.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "1px solid #EFEFEF",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          height: "30px",
                          cursor: "pointer",
                          width: "30px",
                        }}
                        onClick={() => handleRemoveRecipe(i)}
                      >
                        <img
                          width={"100%"}
                          height={"100%"}
                          src={cross}
                          alt="preview"
                        />
                      </Box>
                    </Box>
                  </Paper>
                ))
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Box>

        <SelectRecipeModal
          tempRecipe={tempRecipe}
          setTempRecipe={setTempRecipe}
          open={open}
          recipeType={recipeType}
          setRecipeType={setRecipeType}
          onClose={onClose}
          onSelectRecipes={handleSelectRecipes}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          loading={loading}
          setLoading={setLoading}
          selectedRecipeData={selectedRecipeData}
          setSelectedRecipeData={setSelectedRecipeData}
        />
      </Box>
    </>
  );
};

export default EditDietPlans;
